/* eslint-disable */

var jQuery = require("jquery");
var $ = jQuery;
window.jQuery = jQuery;
window.$ = $;

//var Auth0Lock = require("AuthServiceModule-lock");
//window.Auth0Lock = Auth0Lock;

require("angular");
require("angular-sanitize");
require("angular-resource");
require("angular-animate");
require("angular-aria");
require("angular-cookies");

require("angular-ui-bootstrap");
require("@uirouter/angularjs");

require("angular-storage");
require("angular-jwt");

require("oidc-client");

require("pako");

require("@progress/kendo-ui");
require("kendo.timezones");

require("moment");
require("moment-timezone");

require("clipboard");



//////////////////
// WEBPACK FOOTER
// ./src/core/vendor.js
// module id = B1iV
// module chunks = 0